import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;
var _excluded = ["clientId", "color", "initialDelay", "size"];
import { css, keyframes } from "@emotion/core";
import styled from "@emotion/styled";
import { themed } from "@smartsheet/sds-theme-internal";
import { useCombinedThemeMode } from "@smartsheet/sds-theme-internal";
import React, { useEffect, useState } from "react";
import { neutralDark40 } from "../../constants/colors";
import { SPINNER_CONTAINER_SIZES_MAP, SPINNER_DOT_SIZES_MAP } from "./constants";
export var Spinner = function Spinner(_ref) {
  var clientId = _ref.clientId,
    color = _ref.color,
    initialDelay = _ref.initialDelay,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? "medium" : _ref$size,
    rest = _objectWithoutProperties(_ref, _excluded);
  var themeMode = useCombinedThemeMode();
  var _useState = useState(initialDelay === undefined),
    _useState2 = _slicedToArray(_useState, 2),
    visible = _useState2[0],
    setVisible = _useState2[1];
  useEffect(function () {
    if (initialDelay) {
      var timer = setTimeout(function () {
        setVisible(true);
      }, initialDelay);
      return function () {
        clearTimeout(timer);
      };
    }
  }, [initialDelay]);
  return /*#__PURE__*/React.createElement(Container, _extends({
    size: size
  }, rest, {
    "data-client-id": clientId
  }), visible && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TopDot, {
    color: color,
    size: size,
    themeMode: themeMode
  }), /*#__PURE__*/React.createElement(BottomDot, {
    color: color,
    size: size,
    themeMode: themeMode
  })));
};
var getCubeAnimation = function getCubeAnimation(containerWidth, dotSize) {
  var delta = "".concat(containerWidth - dotSize, "px");
  return keyframes(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    25% {\n        transform: translate(", ", 0);\n    }\n    50% {\n        transform: translate(", ", ", ");\n    }\n    75% {\n        transform: translate(0, ", ");\n    }\n    100% {\n        transform: translate(0, 0);\n    }\n"])), delta, delta, delta, delta);
};
var LayoutStyles = css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    box-sizing: border-box;\n"])));
var Container = styled("div")(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    ", ";\n\n    display: block;\n    font-size: 0;\n    height: ", "px;\n    width: ", "px;\n    position: relative;\n    pointer-events: none;\n"])), LayoutStyles, function (props) {
  return SPINNER_CONTAINER_SIZES_MAP[props.size];
}, function (props) {
  return SPINNER_CONTAINER_SIZES_MAP[props.size];
});
var dotTheme = themed({
  color: {
    "lodestar-light": neutralDark40,
    "ursa-light": "currentColor"
  }
});
var TopDot = styled("div")(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    ", ";\n\n    background-color: ", ";\n    width: ", "px;\n    height: ", "px;\n    display: inline-block;\n    float: none;\n    position: absolute;\n    top: 0;\n    left: 0;\n    border-radius: 50%;\n    animation: ", "\n        1.6s 0s infinite cubic-bezier(0.2, 0, 0, 1);\n"])), LayoutStyles, function (_ref2) {
  var color = _ref2.color,
    themeMode = _ref2.themeMode;
  return color || dotTheme.color(themeMode);
}, function (props) {
  return SPINNER_DOT_SIZES_MAP[props.size];
}, function (props) {
  return SPINNER_DOT_SIZES_MAP[props.size];
}, function (props) {
  return getCubeAnimation(SPINNER_CONTAINER_SIZES_MAP[props.size], SPINNER_DOT_SIZES_MAP[props.size]);
});
var BottomDot = styled(TopDot)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n    animation-delay: -0.8s;\n"])));
//# sourceMappingURL=Spinner.js.map